import { usePostHog } from 'posthog-js/react'

type SignupModuleName = 'histogram' | 'pane' | 'main' | 'modal'

export function useSignupTracking() {
  const posthog = usePostHog()

  const trackSignupClick = (moduleName: SignupModuleName) => {
    posthog.capture('clicked_signup_all', {
      screen_name: 'salary',
      module_name: `g2g-${moduleName}`
    })
  }

  return { trackSignupClick }
} 